document.addEventListener('DOMContentLoaded', function() {
    if (window.location.pathname === '/pages/manuals') {
      function hideKlaviyoElement() {
        var elements = document.querySelectorAll('.kl-private-reset-css-Xuajs1');
        elements.forEach(function(element) {
          element.style.display = 'none';
        });
      }
  
      hideKlaviyoElement();
  
      const observer = new MutationObserver(function(mutationsList, observer) {
        for (let mutation of mutationsList) {
          if (mutation.type === 'childList' || mutation.type === 'subtree') {
            hideKlaviyoElement();
          }
        }
      });
  
      observer.observe(document.body, { childList: true, subtree: true });
    }
});
  
